/**
 * Trims and deduplicates OAuth product scope strings stored on secrets and tokens.
 */
export function normalizeProductOAuthSecretScopes(scopes: readonly string[]): string[] {
  const out = new Set<string>()
  for (const raw of scopes) {
    const trimmed = raw.trim()
    if (trimmed) {
      out.add(trimmed)
    }
  }
  return [...out]
}
